// Autogenerated file
export const fixRouteBidStatusesEnum = {
    Draft: "Draft",
    New: "New",
    InProgress: "InProgress",
    Completed: "Completed",
    Canceled: "Canceled",
};
export const fixRouteBidStatuses = [
    { label: "Черновик", value: "Draft" },
    { label: "Новый", value: "New" },
    { label: "В работе", value: "InProgress" },
    { label: "Завершен", value: "Completed" },
    { label: "Отменен", value: "Canceled" },
];
